import { QueryStatus } from 'react-query';

/**
 * returns a single status derived from several different statuses coming from
 * the different queries this hook could be running
 */
export function getQueryStatus(statuses: QueryStatus[]): QueryStatus {
  // if there's at least one error, consider the entire status to be `error`
  if (statuses.includes('error')) return 'error';

  // if there are no errors, but at least one query is loading, entire status
  // will be considered `loading`
  if (statuses.includes('loading')) return 'loading';

  // if we reach this point, we can safely assume that there are no errors or
  // queries loading. So that means the statuses are either `idle` or `success`
  // if there is at least one `success`, than consider the overall status `success`
  if (statuses.includes('success')) return 'success';

  // otherwise, all statuses will be `idle`
  return 'idle';
}
